// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"493":"b6a203ac","546":"4ef5aca4","719":"acf09da4","793":"35d29a44","795":"15a23183","869":"8e30ce6b"}[chunkId] + ".css";
};